export default class ProductsHelper {
  static icons = {
    "Aster": [
      "CA",
      "Natural Stone",
      "RB"
    ],
    "Ava Rose": [
      "CA",
      "Natural Stone",
      "RB"
    ],
    "Dusk": [
      "LA",
      "Natural Stone",
      "Genuine Gold"
    ],
    "Kate Spade": [
      "NY",
      "Weekend Wear",
      "Glass Stone Pave"
    ],
    "Kendra Scott": [
      "TX",
      "Natural Stone",
      "Genuine Gold"
    ],
    "Loren Hope": [
      "RI",
      "Party Pieces",
      "Glass Stone Pave"
    ],
    "Melinda Maria": [
      "LA",
      "Handcrafted",
      "Genuine Gold"
    ],
    "Nakamol": [
      "IL",
      "Natural Stone",
      "Handcrafted"
    ],
    "Perry Street": [
      "NY",
      "Party Pieces",
      "Glass Stone Pave"
    ],
    "Rudiment": [
      "SF",
      "Everyday Essentials",
      "Genuine Gold"
    ],
    "SLATE": [
      "NY",
      "Natural Stone",
      "RB"
    ],
    "Sophie Harper": [
      "CA",
      "Everyday Essentials",
      "RB"
    ],
    "WILDE": [
      "SF",
      "Weekend Wear",
      "Handcrafted"
    ],
    "gorjana": [
      "CA",
      "Everyday Essentials",
      "Genuine Gold"
    ]
  };

  static iconMap = {
    "CA": "Designed in CA",
    "Everyday Essentials": "Everyday Essentials",
    "Genuine Gold": "Finished in Genuine Gold & Silver",
    "Glass Stone Pave": "Made with Glass Stones and Pavé",
    "Handcrafted": "Handcrafted Details",
    "IL": "Designed in Chicago, IL",
    "LA": "Designed in LA",
    "NY": "Designed in NY",
    "Natural Stone": "Made with Natural Stone",
    "Party Pieces": "Party Pieces",
    "RB": "Rocksbox Exclusive",
    "RI": "Designed in Rhode Island",
    "SF": "Designed in SF",
    "TX": "Designed in Austin, TX",
    "Weekend Wear": "Weekend Wear"
  };

  static iconText (icon) {
    return this.iconMap[icon];
  }

}
